/*
 * @Author       : wangyanan
 * @Date         : 2025-01-13 16:25:00
 * @LastEditTime : 2025-01-13 16:35:23
 * @LastEditors  : wangyanan
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Router from './router/index'
import defaultSettings from '@/defaultSettings'
// 添加水印
import watermark from '@/utils/watermark'
import { getCookie } from '@/utils/cookie'
import { proxy } from 'ajax-hook'
import './index.css'
import { message } from 'antd'

watermark()

// CSRF 防御，拦截 XHR 请求
proxy({
  // 请求发起前进入
  onRequest: (config, handler) => {
    if (config.url.indexOf('opencms.anjuke.') > -1) {
      config.headers['X-CSRF-TOKEN'] = getCookie('stoken')
      config.headers['X-AJK-CSRF-TOKEN'] = getCookie('ajk_probe_token')
    }
    handler.next(config)
  },
  // 请求发生错误时进入，比如超时；注意，不包括http状态码错误，如404仍然会认为请求成功
  onError: (err:any, handler) => {
    if (err && err.error && err.error.type === 'timeout') {
      message.error('请求超时，请稍后重试')
    } else {
      handler.next(err)
    }
  },
  // 请求成功后进入
  onResponse: (response, handler) => {
    handler.next(response)
  }
})

// 忽略的异常
const ignoreErrors = [
  // https://github.com/react-component/align/pull/72#event-3660686845
  'Error:ResizeObserver loop limit exceeded',
  // https://github.com/react-component/align/pull/72#event-3660686845
  'Error:ResizeObserver loop completed with undelivered notifications',
  'Error:Script error',
  'UnhandledRejection:Non-Error'
]

const getCurrentBeidouId = () => {
  const beidouPidConfig: { [subappName: string]: number } = {
    '/webapp/main': 134,
    '/webapp/sydc': 239,
    '/webapp/vr': 192,
    '/webapp/qhy': 221,
    '/webapp/yezhu': 349,
    '/webapp/bizdata': 150,
    '/webapp/qtf': 640,
    '/webapp/shikan': 1205
  }
  const url = location.pathname || ''
  const urlKey = url.match(/^\/webapp\/[a-z]+/)
  if (!(urlKey && urlKey[0])) {
    // 主应用自带页面
    return defaultSettings.beidouPid
  } else {
    const key = urlKey[0]
    return beidouPidConfig[key] || defaultSettings.beidouPid
  }
}

window.Beidou &&
    window.Beidou.init({
      projectId: defaultSettings.beidouPid,
      isProd: true,
      // isProd: process.env.NODE_ENV === 'production',
      isDebug: false,
      ignoreErrors,
      // 上报之前分发流量
      beforeSend: (event: any) => {
        if (event.type === 'breadcrumb') {
          return event
        }
        event.projectId = getCurrentBeidouId()
        if (event.type && event.type === 'exception') {
          console.warn('beidou发现异常，准备上报', event)
        }
        return event
      }
    })

ReactDOM.render(<Router />, document.getElementById('root'))
